import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { humanCase } from '@paragon/utilities';

import { getActiveStation } from '../selectors/getActiveStation';
import { setStatus } from '../slices/productionModelsSlice';
import { AsyncThunkActionReturn } from './thunkActions';

export function markBundleFinishedAssembly(bundleGuid: string): AsyncThunkActionReturn<boolean> {
  return async function markBundleFinishedAssemblyThunkAction(dispatch, getState) {
    const status = 'FinishedAssembly';
    const productionComponentInstanceGuidsForBundle =
      getState().productionModels.orderedProductionComponentInstancesByBundleGuid[bundleGuid].map(
        (instance) => instance.guid,
      );

    try {
      await designService.productionComponentInstances.setStatus(productionComponentInstanceGuidsForBundle, status);
      dispatch(setStatus({ instanceGuids: productionComponentInstanceGuidsForBundle, status }));
    } catch (error) {
      dispatch(enqueueError(`Error marking bundle "${humanCase(status)}"`));
      console.error(error);
    }

    try {
      const station = getActiveStation(getState());
      if (station !== null && station.followsSchedule) {
        const finishedTime = new Date();
        await Promise.all(
          productionComponentInstanceGuidsForBundle.map((instanceGuid) =>
            designService.productionComponentInstanceBuildLogs.setEndProduction(
              instanceGuid,
              station.guid,
              finishedTime,
              true,
            ),
          ),
        );
      }
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
}
